import {ListConfigs} from '../../app/sharedComponent/SearchList/SearchList.types'
import {filterConfig} from '../Global.types'
import {productSetupEnumType} from '../GlobalEnum.types'
export const PRODUCTLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'Product Name',
    apiFieldName: 'productName',
    type: 'TEXT',
    columnWidth: '200',
  },
  {
    headerName: 'Product Code',
    apiFieldName: 'productCode',
    type: 'TEXT',
    columnWidth: '200',
  },
  {
    headerName: 'Commodity',
    apiFieldName: 'commodityType',
    type: 'TEXT',
    columnWidth: '125',
  },
  {
    headerName: 'Contract Type',
    apiFieldName: 'contractType',
    type: 'TEXT',
    columnWidth: '125',
  },
  {
    headerName: 'Customer Type',
    apiFieldName: 'customerType',
    type: 'TEXT',
    columnWidth: '150',
  },
  {
    headerName: 'Utility',
    apiFieldName: 'utility',
    type: 'TEXT',
    columnWidth: '200',
  },
  {
    headerName: 'Rate',
    apiFieldName: 'rate',
    type: 'TEXT',
    columnWidth: '90',
  },
  // As per discussion, these 3 fields hide for now
  // {
  //   headerName: 'Termination Fee',
  //   apiFieldName: 'terminationFee',
  //   type: 'TEXT',
  //   columnWidth: '150',
  // },
  // {
  //   headerName: 'Service Fee',
  //   apiFieldName: 'serviceFee',
  //   type: 'TEXT',
  //   columnWidth: '150',
  // },
  // {
  //   headerName: 'Adder',
  //   apiFieldName: 'adder',
  //   type: 'TEXT',
  //   columnWidth: '150',
  // },
  {
    headerName: 'Term',
    apiFieldName: 'term',
    type: 'TEXT',
    columnWidth: '80',
  },
  {
    headerName: 'TPV Script',
    apiFieldName: 'tpvScriptStatus',
    type: 'STATUS_BADGE',
    columnWidth: '90',
  },
]
export const SOLARPRODUCTLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'Product Name',
    apiFieldName: 'productName',
    type: 'TEXT',
    columnWidth: '200',
  },
  {
    headerName: 'Product',
    apiFieldName: 'solarProduct',
    type: 'TEXT',
    columnWidth: '90',
  },
  {
    headerName: 'State',
    apiFieldName: 'state',
    type: 'TEXT',
    columnWidth: '90',
  },
  {
    headerName: 'Utility',
    apiFieldName: 'utility',
    type: 'TEXT',
    columnWidth: '90',
  },
  {
    headerName: 'Available Customer',
    apiFieldName: 'availableCustomers',
    type: 'TEXT',
    columnWidth: '90',
  },
  {
    headerName: 'TPV Script',
    apiFieldName: 'tpvScriptStatus',
    type: 'STATUS_BADGE',
    columnWidth: '90',
  },
]
export const filterDataFeedHelper: (
  data: productFilterDataFeedNames[],
  enumType: productSetupEnumType
) => filterConfig = (data: productFilterDataFeedNames[], enumType: productSetupEnumType) => {
  switch (enumType) {
    case 'CONTRACT_TYPE':
      return {
        key: 'contractTypeId',
        label: 'Contract Type',
        type: 'STRING',
        options: data.map(({value, id}) => ({value: id, name: value})),
      }
    case 'UTILITY':
      return {
        key: 'utilityId',
        label: 'Utility',
        type: 'STRING',
        options: data.map(({value, id}) => ({value: id, name: value})),
      }
    case 'CUSTOMER_TYPE':
      return {
        key: 'customerTypeId',
        label: 'Customer Type',
        type: 'STRING',
        options: data.map(({value, id}) => ({value: id, name: value})),
      }
    case 'TPV_STATUS':
      return {
        key: 'tpvScriptStatus',
        label: 'TPV Status',
        type: 'STRING',
        options: data.map(({value, id}) => ({value: id, name: value})),
      }
    case 'PRODUCT_STATUS':
      return {
        key: 'isActive',
        label: 'Product Status',
        type: 'BOOLEAN',
        options: data.map(({value, id}) => ({value: id, name: value})),
      }
    default:
      return {
        key: '',
        label: '',
        type: 'STRING',
        options: [],
      }
  }
}
export type productFilterDataFeed = {
  enum: productSetupEnumType
  names: productFilterDataFeedNames[]
}
export type productFilterDataFeedNames = {
  id: string
  value: string
}
